import type { FormAsyncComboboxProps } from '@/_components';
import { FormAsyncCombobox } from '@/_components';

import { useGetRecruitingHiringCriteriaCategoriesMutation } from '../apis';
import type { RecruitingHiringCriteriaCategoryQueryLinkerSchema } from '../schemas';

export function RecruitingHiringCriteriaCategoriesMultiSelect({
  disabled,
  ...props
}: FormAsyncComboboxProps<RecruitingHiringCriteriaCategoryQueryLinkerSchema, true>) {
  return (
    <FormAsyncCombobox
      {...props}
      isMulti
      showBorder
      itemToString={(item) => item.name}
      keyExtractor={(item) => item?.id?.toString?.() ?? null}
      getMultiValueLabel={(item) => item.name}
      useApi={useGetRecruitingHiringCriteriaCategoriesMutation}
      disabled={disabled}
    />
  );
}
